import { V3Models } from "@istari/istari-client";
import { useQuery } from "@tanstack/react-query";

import { normalizeFileExtension } from "~/utils/file";

import { resourceQueryOptions } from "./api/resource-query-options";

export function useResourceRevisionContent(
  resourceId: string | undefined,
  revisionId: string | undefined,
  enabled: boolean,
) {
  return useQuery({
    ...resourceQueryOptions.revisionContent(resourceId || "", revisionId || ""),
    select: selectResourceRevisionContent,
    enabled: enabled && !!resourceId && !!revisionId,
  });
}

/**
 * Selector for resource revision content - transforms raw data to component shape
 */
function selectResourceRevisionContent(
  data:
    | {
        content: Uint8Array;
        revision: V3Models.ResourceRevisionDto;
        resourceId: string;
      }
    | undefined,
) {
  if (!data) return undefined;
  const { content, revision } = data;

  return {
    content: content,
    revisionId: revision.fileRevisionId,
    extension: normalizeFileExtension(revision.extension),
  };
}
